/**
 * Riporta sull'attività CRM il colore scelto A MANO dall'operatore sull'evento
 * Google gemello (quello nascosto dalla dedup di getEnabledEvents).
 *
 * Si applica SOLO se l'evento Google ha un colorId esplicito
 * (metadata.google_color_id, settato nel mapping di fetchGoogleEvents): senza
 * questo guard-rail ogni attività sincronizzata erediterebbe il colore di
 * default del calendario, cambiando colore a tutto il CRM.
 * Il verde "completata" resta prioritario: è un segnale di stato, non estetico.
 */

/** Verde attività completata/annullata — deve combaciare con il mapping in calendarStore. */
export const COMPLETED_ACTIVITY_COLOR = '#10B981';

interface OverlayEvent {
  id: string;
  color?: string;
  metadata?: Record<string, unknown> | null;
}

const toStoreGoogleId = (gid: string) => `google-${gid.replace(/^google-/, '')}`;

export function overlayGoogleEventColors<T extends OverlayEvent>(
  activities: T[],
  googleEvents: OverlayEvent[]
): T[] {
  const explicitColors = new Map<string, string>();
  for (const event of googleEvents) {
    if (event.color && event.metadata?.google_color_id) {
      explicitColors.set(event.id, event.color);
    }
  }
  if (explicitColors.size === 0) return activities;

  return activities.map(activityEvent => {
    if (activityEvent.color === COMPLETED_ACTIVITY_COLOR) return activityEvent;
    const gid = activityEvent.metadata?.google_event_id;
    if (typeof gid !== 'string' || !gid) return activityEvent;
    const googleColor = explicitColors.get(toStoreGoogleId(gid));
    if (!googleColor || googleColor === activityEvent.color) return activityEvent;
    return { ...activityEvent, color: googleColor };
  });
}
